import { format } from "date-fns";
import { resolveMinStayLength } from "./_context.js";

export function createUSeDirectBookingStrategy({ bookingBaseUrl }) {
  return {
    buildBookingUrl(ctx) {
      const { site, arrivalDate } = ctx;
      if (!arrivalDate) return site.reserveUrl;
      const url = new URL(site.reserveUrl);
      const route = url.hash.split("?")[0];
      const params = new URLSearchParams({
        date: format(arrivalDate, "yyyy-MM-dd"),
        night: String(resolveMinStayLength(ctx)),
      });
      url.hash = `${route}?${params}`;
      return url.toString();
    },

    buildPreviewUrl(site, facility) {
      const placeId = facility?.extraAttributes?.placeId;
      return placeId ? `${bookingBaseUrl}/#!park/${placeId}` : site.reserveUrl;
    },

    describeBookingInputs() {
      return {
        inputs: {
          arrivalDate: {
            status: "required",
            notes:
              "Prefilled by the booking app's date hash parameter on fresh navigation.",
          },
          departureDate: {
            status: "required",
            notes:
              "Converted to the night hash parameter; otherwise uses the request's minimum stay.",
          },
          ref: {
            status: "ignored",
            notes:
              "The stored URL identifies the park and campground. Select the numbered unit on the booking site.",
          },
          partySize: {
            status: "ignored",
            defaultValue: 1,
            notes: "Party size is selected on the booking site.",
          },
        },
      };
    },
  };
}
